module.exports = __webpack_public_path__ + "static/img/company-logo2.3e4f8fde.jpg";